import React, { useState, createContext, useContext } from "react";

// Create a context for the re-render trigger
const ForceRenderContext = createContext();

// Provider component
export const ForceRenderProvider = ({ children }) => {
  const [trigger, setTrigger] = useState(0);

  // Function to force re-render
  const forceRender = () => {
    setTrigger((prev) => prev + 1);
  };

  // The value that will be given to the context
  const value = { forceRender, trigger };

  return (
    <ForceRenderContext.Provider value={value}>
      {children}
    </ForceRenderContext.Provider>
  );
};

// Hook to use the forceRender function and trigger state in any component
export const useForceRender = () => {
  const context = useContext(ForceRenderContext);
  if (context === undefined) {
    throw new Error("useForceRender must be used within a ForceRenderProvider");
  }
  return context;
};
